import React from "react";

function Otcheny() {
  return <div>Otcheny</div>;
}

export default Otcheny;
